import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await login(email.trim(), password);
            toast.success("Backbone access granted.");
            const to = loc.state?.from?.pathname || "/admin";
            nav(to, { replace: true });
        } catch (err) {
            const detail = err?.response?.data?.detail || "Authentication failed.";
            setError(typeof detail === "string" ? detail : "Authentication failed.");
            toast.error("Handshake rejected.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-void text-ghost flex items-center justify-center px-6 grain scanlines" data-testid="admin-login">
            <div className="absolute inset-0 bg-grid-amber opacity-20 animate-grid-drift" />
            <div className="relative w-full max-w-md glass float-depth">
                <div className="px-4 py-2 border-b border-border bg-black/40 flex items-center justify-between">
                    <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-signal flex items-center gap-2">
                        <Lock size={11} /> apib://root — authenticate
                    </span>
                    <Link to="/" className="text-[10px] font-mono uppercase tracking-[0.3em] text-muted hover:text-signal" data-testid="admin-login-back">[exit]</Link>
                </div>
                <form onSubmit={submit} className="p-6 space-y-4">
                    <div>
                        <div className="font-display text-3xl font-black tracking-tighter uppercase glow-amber text-signal">Admin Console</div>
                        <div className="font-mono text-xs text-muted mt-1">Root credentials required.</div>
                    </div>
                    <div>
                        <label className="block text-[10px] font-mono uppercase tracking-[0.3em] text-muted mb-1">EMAIL</label>
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            data-testid="admin-email"
                            required
                            autoComplete="username"
                            placeholder="admin@apib.io"
                            className="w-full bg-transparent border-b border-border focus:border-signal py-2 font-mono text-base text-ghost outline-none placeholder:text-muted transition-colors"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] font-mono uppercase tracking-[0.3em] text-muted mb-1">PASSWORD</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            data-testid="admin-password"
                            required
                            autoComplete="current-password"
                            placeholder="••••••••••"
                            className="w-full bg-transparent border-b border-border focus:border-signal py-2 font-mono text-base text-ghost outline-none placeholder:text-muted transition-colors"
                        />
                    </div>
                    {error && <div className="text-xs font-mono text-red-400" data-testid="admin-error">› {error}</div>}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-submit"
                        data-cursor-label="AUTHENTICATE"
                        className="btn-signal w-full inline-flex items-center justify-center gap-2 px-5 py-3 font-mono uppercase tracking-[0.2em] text-xs disabled:opacity-40"
                    >
                        {loading ? "Establishing…" : "Authenticate"} <ArrowRight size={14} />
                    </button>
                    <div className="pt-2 text-[10px] font-mono text-muted uppercase tracking-[0.3em]">
                        Sentinel-monitored · 5 failed attempts · 15-min lockout
                    </div>
                </form>
            </div>
        </div>
    );
}
